import React from "react";
import ReactDOM from "react-dom/client";
import WidgetRenderer from "../Components/WidgetRenderer/WidgetRenderer";

export default async function init() {
  const app = document.createElement("div");
  app.id = "root";
  document.body.appendChild(app);
  const root = ReactDOM.createRoot(app);

  const remount = () => root.render(<WidgetRenderer />);

  // Exposed so legacy JS/ERB can re-trigger widget mounting after dynamic HTML injection
  (window as Window & { __remountWidgets?: () => void }).__remountWidgets = remount;

  if (!document.querySelector("[data-react-component]")) return;

  remount();
  const event = new Event("react:app:init");
  window.dispatchEvent(event);
}
